import { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { toast } from "sonner";
import { Loader2, LogOut, Smartphone, CheckCircle2, RefreshCw } from "lucide-react";
import { api } from "@/lib/api";
import WaIcon from "@/components/whatsapp/WaIcon";

const STEPS = [
    "Hapni WhatsApp në celularin tuaj",
    "Prekni Menu ⋮ ose Cilësimet dhe zgjidhni Pajisjet e lidhura",
    "Prekni Lidh një pajisje",
    "Drejtoni celularin te ky ekran për të skanuar kodin QR",
];

export default function WaQrConnect({ onChange }) {
    const [st, setSt] = useState({ status: "disconnected" });
    const [busy, setBusy] = useState(false);

    const load = () => api.get("/admin/whatsapp/qr").then((r) => { setSt(r.data); return r.data; });
    useEffect(() => { load(); }, []);
    useEffect(() => {
        if (!["connecting", "qr"].includes(st.status)) return;
        const t = setInterval(async () => {
            const d = await load();
            if (d.status === "connected") { toast.success("WhatsApp u lidh!"); onChange?.(); }
        }, 2000);
        return () => clearInterval(t);
    }, [st.status]); // eslint-disable-line react-hooks/exhaustive-deps

    const connect = async () => { setBusy(true); try { await api.post("/admin/whatsapp/qr/connect"); await load(); } finally { setBusy(false); } };
    const logout = async () => {
        if (!window.confirm("Ta shkëpus WhatsApp-in nga faqja?")) return;
        setBusy(true);
        try { await api.post("/admin/whatsapp/qr/logout"); await load(); onChange?.(); } finally { setBusy(false); }
    };

    if (st.status === "connected") {
        return (
            <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-6 flex flex-wrap items-center gap-4" data-testid="wa-qr-connected">
                <CheckCircle2 className="w-10 h-10 text-emerald-600" />
                <div className="flex-1 min-w-0">
                    <div className="font-display font-black uppercase text-emerald-700">WhatsApp është i lidhur</div>
                    <div className="text-sm font-mono text-slate-600">{st.me ? `+${st.me}` : "Numri juaj"} · mesazhet hyjnë dhe dalin direkt nga paneli</div>
                </div>
                <button onClick={logout} disabled={busy} className="btn-outline text-red-600" data-testid="wa-qr-logout"><LogOut className="w-4 h-4" /> Shkëput</button>
            </div>
        );
    }

    return (
        <div className="grid md:grid-cols-[1fr_auto] gap-8 items-center rounded-xl border border-slate-200 p-6" data-testid="wa-qr-panel">
            <div>
                <div className="flex items-center gap-2 font-display font-black text-xl uppercase mb-1"><WaIcon className="w-6 h-6 text-[#25D366]" /> Lidhni WhatsApp-in me faqen</div>
                <p className="text-sm text-slate-500 mb-5">Si te WhatsApp Web: skanoni kodin me celularin dhe bisedat me klientët shfaqen këtu.</p>
                <ol className="space-y-3">
                    {STEPS.map((s, i) => (
                        <li key={i} className="flex gap-3 text-sm">
                            <span className="w-6 h-6 rounded-full bg-[#25D366]/15 text-[#25D366] grid place-items-center text-xs font-bold shrink-0">{i + 1}</span>
                            <span className="text-slate-700">{s}</span>
                        </li>
                    ))}
                </ol>
                <p className="text-[11px] text-slate-500 mt-5 flex items-center gap-1.5"><Smartphone className="w-3.5 h-3.5" /> Lidhje jo-zyrtare (linked device): shmangni mesazhet masive te numra që s'ju kanë shkruar.</p>
            </div>
            <div className="w-[264px] h-[264px] rounded-xl bg-white border border-slate-200 grid place-items-center admin-light relative" data-testid="wa-qr-box">
                {st.status === "qr" && st.qr ? (
                    <QRCodeSVG value={st.qr} size={232} level="L" data-testid="wa-qr-code" />
                ) : st.status === "connecting" ? (
                    <Loader2 className="w-8 h-8 animate-spin text-[#25D366]" />
                ) : (
                    <button onClick={connect} disabled={busy} className="flex flex-col items-center gap-2 text-sm font-bold text-[#128C7E]" data-testid="wa-qr-start">
                        <span className="w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center"><RefreshCw className={`w-6 h-6 ${busy ? "animate-spin" : ""}`} /></span>
                        Shfaq kodin QR
                    </button>
                )}
            </div>
        </div>
    );
}
